import { useEffect, useState } from 'react';
import { subscribeRaidControl } from '../api/raidControlApi.js';

// 접속 명단은 관제 방 소켓이 준다. 방 DO 는 붙어 있는 소켓으로 명단을 만들어 누가 들고 날
// 때마다 쏘고 있었고, 클라이언트도 받아만 두고 쓰지 않았다.
//
// 전에는 이걸 유니온 전체를 세는 별도 연결로 했는데, 그 연결이 라우트와 무관하게 모든
// 페이지에서 상시 붙어 있었다. 이제 이 화면이 열려 있는 동안만 붙고, 관제 방에 이미 들어와
// 있으면 같은 구독으로 합쳐져 추가 연결이 생기지 않는다.
//
// 그래서 '온라인'의 뜻이 바뀐다: 사이트에 있는 사람이 아니라 '지금 관제 방에 있는 사람'이다.
export function useRaidRoomPresence({ unionId, seasonId }) {
  const normalizedUnionId = String(unionId || '').trim();
  const normalizedSeasonId = String(seasonId || '').trim();
  const [state, setState] = useState({ members: [], status: 'connecting' });

  useEffect(() => {
    if (!normalizedUnionId || !normalizedSeasonId) {
      setState({ members: [], status: 'unavailable' });
      return undefined;
    }
    setState({ members: [], status: 'connecting' });
    return subscribeRaidControl({
      unionId: normalizedUnionId,
      seasonId: normalizedSeasonId,
      onTimelineChange: (change) => {
        if (change?.source === 'presence') {
          setState({ members: Array.isArray(change.users) ? change.users : [], status: 'open' });
          return;
        }
        if (change?.source === 'realtime-status') {
          const open = String(change.status || '') === 'open';
          setState((current) => (open === (current.status === 'open')
            ? current
            : { members: open ? current.members : [], status: open ? 'open' : 'connecting' }));
        }
      },
    });
  }, [normalizedUnionId, normalizedSeasonId]);

  return state;
}
